module.exports = __webpack_public_path__ + "a372057ef41ccf95681b203712c0a39c.png";